import { Pto } from '@outcoreaix/pto'
import { Flex, Typography, List } from 'antd'
import { useGetCertificateStatusQuery } from 'api/learn-worlds-api'
import { AppRoutes } from 'app/app-routes'
import { ComponentWithSpinner } from 'components'
import { CpdLoginButton } from 'features/learn-worlds'
import { useQueryParams } from 'hooks/useQueryParams'
import { FC, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

const CpdNotice: FC = () => {
  const { getParam } = useQueryParams()
  const callbackUrl = getParam(Pto.App.ParamKeyEnum.CallbackUrl)
  const navigate = useNavigate()

  const { data: cpdStatus, isLoading } = useGetCertificateStatusQuery()

  const benefits = [
    'Introduce you to Alex AI and its core capabilities',
    'Explain best practices for using the platform',
    'Confirm your completion with an official certificate'
  ]

  useEffect(() => {
    if (!isLoading && cpdStatus?.completed) {
      if (callbackUrl) {
        navigate(callbackUrl)
      } else {
        navigate(AppRoutes.main)
      }
    }
  }, [isLoading, cpdStatus, callbackUrl, navigate])

  if (isLoading) {
    return <ComponentWithSpinner isLoading />
  }

  return (
    <Flex justify="center" align="center" style={{ minHeight: '100vh', padding: 16 }}>
      <Flex className="max-w-[650px]">
        <Flex vertical gap={20}>
          <Typography.Title level={2} style={{ marginBottom: 0, textAlign: 'center' }}>
            Welcome!
          </Typography.Title>

          <Typography.Paragraph style={{ textAlign: 'center' }}>
            To ensure you get the most value from the platform and can use Alex AI effectively, all staff members are
            required to complete the Alex AI CPD training before accessing Outcore’s features.
          </Typography.Paragraph>

          <div>
            <Typography.Text strong>This short training will:</Typography.Text>
            <List dataSource={benefits} renderItem={(item) => <List.Item>{item}</List.Item>} />
          </div>

          <CpdLoginButton type="primary" size="large">
            Access the Alex AI CPD Module
          </CpdLoginButton>

          <Typography.Text type="secondary" style={{ textAlign: 'center' }}>
            Once you complete the module and receive your certificate, please reload the page to unlock access to
            Outcore’s features.
          </Typography.Text>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default CpdNotice
